<template>
  <div class="audit-info auto1200">
    <div class="header">
      <div class="title">申报单ID：{{ id }}</div>
      <ul class="links">
        <li><a @click="jump('/process')">查看详细入驻流程</a></li>
        <li><a href="https://www.yuque.com/docs/share/7489dfff-bc57-47fb-9af6-7696cdf67d4e" target="_blank">入驻帮助</a></li>
      </ul>
    </div>
    <div v-if="status === 1" class="info-card">
      <div class="content pending">
        <div class="icon"><img src="../../assets/img/icon-audit-pending.png"></div>
        <div class="info">
          <header>
            <span class="title blue">审核中</span>
            <span v-if="duration" class="text">预计{{ duration }}小时内审核完成</span>
            <span v-else class="text">优先审核中，您也可以<a @click="urge">点击催单</a></span>
          </header>
          <div class="id">申报单ID：{{ id }}</div>
          <div class="tips">
            感谢您的信任，我们已经收到您的申请，正在加急审核中～
            如有问题，可联系 zuhaofeng@xiaomi.com 或者项目经理。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { urgeApply } from '@/api/merchant'

export default {
  props: {
    status: {
      type: Number,
      default: 1
    }
  },
  computed: {
    ...mapState({
      id: 'applicationId',
      duration: 'reviewDuration'
    })
  },
  methods: {
    jump(path) {
      this.$router.push(path)
    },
    async urge() {
      const result = await urgeApply()
      if (!result.code) this.$message.success('催单成功！')
      else this.$message.error(result.msg)
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  padding-top: 21px;
  padding-bottom: 13px;
  padding-left: 5px;
  border-bottom: 1px solid #DEDDDD;
  line-height: 12px;
  display: flex;
  justify-content: space-between;

  .title {
    font-size: 16px;
    font-weight: 500;
  }

  ul.links {
    width: 400px;
    margin: 0;
    padding-right: 5px;

    li {
      display: inline-block;
      margin-left: 30px;
    }
  }
}

a {
  font-size: 12px;
  color: #457BFC;
  text-align: center;
  line-height: 12px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: #457BFC;
  }
}

.info-card {
  height: 400px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;

  .content {
    display: flex;

    &.error .info {
      padding-top: 12px;
    }
  }

  .icon {
    display: flex;
    align-items: center;

    img {
      height: 72px;
    }
  }

  .info {
    margin-left: 30px;
    width: 325px;

    .title {
      font-size: 18px;
      padding-right: 10px;
      line-height: 25px;
      font-weight: 500;

      &.blue {
        color: #3C7DEF;
      }

      &.red {
        color: #E00C0C;
      }
    }

    .text {
      font-size: 12px;
      line-height: 25px;
      color: #999999;
      line-height: 12px;
    }

    .id {
      font-size: 12px;
      line-height: 12px;
      padding-top: 8px;
      color: #666666;
      padding-top: 5px;
    }

    .tips {
      font-size: 12px;
      color: #999999;
      line-height: 18px;
      padding-top: 9px;
    }
  }
}
</style>
